import { inject, Injectable } from "@angular/core";
import { API_BASE_FILE_URL } from "../utils";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FilesPath } from "../enum/filte-type";
import { FILE_API_URL } from "../constants";

@Injectable({
    providedIn: 'root',
  })
  export class FileService {
    http = inject(HttpClient);
    apiBaseUrl = inject(API_BASE_FILE_URL);

  
    uploadFile(file: File, baseFolder: FilesPath): Observable<{ result: string }> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<{ result: string }>(`${this.apiBaseUrl}${FILE_API_URL.upload_file}?baseFolder=${baseFolder}`, formData);
    }

    uploadFiles(files: File[], baseFolder: FilesPath): Observable<{ result: string[] }> {
        const formData = new FormData();
        files.forEach((file) => formData.append('files', file));
        return this.http.post<{ result: string[] }>(`${this.apiBaseUrl}${FILE_API_URL.upload_files}?baseFolder=${baseFolder}`, formData);
    }
  }
  